// 入力画面 PDFボタン文言
document.addEventListener("DOMContentLoaded", () => {
	const uploadBtn = document.querySelector(".cd-upload-btn");
	if (uploadBtn) {
		uploadBtn.textContent = "ファイルを選択";
	}
});

// 確認画面 PDFファイル名
document.addEventListener("DOMContentLoaded", () => {
	// 確認画面に出ている URL テキストをファイル名だけに置き換える
	document.querySelectorAll(".entryConfirm__file").forEach((el) => {
		const raw = el.textContent.trim();
		if (!raw) return;

		// 複数ファイルの場合、改行区切りでURLが入ってることが多い
		const urls = raw.split(/\r?\n/).filter(Boolean);

		const names = urls.map((url) => {
			// 末尾の1要素（test.pdf だけ）を取る
			return url.trim().split("/").pop();
		});

		// ファイル名だけを改行区切りで表示
		el.textContent = names.join("\n");
	});
});
